import MediaQueries from '../../../shared/helpers/MediaQueries';

/**
 * Import AddToCart
 *
 */
export function importAddToCartChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-AddToCart' */ '../../Cart/AddToCartHeader/AddToCartHeader'
  ).then(({ default: AddToCartHeader }) => {
    const addToCart = new AddToCartHeader();
    addToCart.execute();
  });
}

/**
 * Import Alert
 *
 */
export function importAlertChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-AddAlert' */ '../../AddAlert/AddAlert'
  ).then(({ default: AddAlert }) => {
    new AddAlert();
  });
}

/**
 * Import Tracking Product
 *
 */
export function importTrackingProductChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-TrackingProduct' */ '../../../Services/Tracking/TrackingProductPage'
  ).then(({ default: TrackingProductPage }) => {
    new TrackingProductPage();
  });
}

/**
 * Import media Mobile
 *
 */
export function importMediaMobileChunks() {
  if (MediaQueries.mobileMedia.matches) {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-MediasSliderMobile' */ '../Medias/MediasSliderMobile/MediasSliderMobile'
    ).then(({ default: mediasSliderMobile }) => {
      mediasSliderMobile();
    });
  }
}

/**
 * Import media Desktop
 *
 */
export function importMediaDesktopChunks() {
  if (
    !MediaQueries.mobileMedia.matches &&
    document.querySelector('.js-sliderVerticalThumbnail')
  ) {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-MediasSliderDesktop' */ '../Medias/MediasSliderDesktop/MediasSliderDesktop'
    ).then(({ default: MediasSliderDesktop }) => {
      new MediasSliderDesktop();
    });
  }
}

/**
 * Import media Popin
 *
 */
export function importMediaPopinChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-MediasPopin' */ '../Medias/MediasPopin/MediasPopin'
  ).then(({ default: MediasPopin }) => {
    new MediasPopin();
  });
}

/**
 * Import Sidebar
 *
 */
export function importSidebarChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-Sidebar' */ '../Sidebar/Sidebar'
  ).then(({ default: Sidebar }) => {
    new Sidebar();
  });
}

/**
 * Import Reviews
 *
 */
export function importReviewsChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ReviewsChunk' */ '../ReviewsChunk/ReviewsChunk'
  ).then(({ default: ReviewsChunk }) => {
    new ReviewsChunk();
  });
}

/**
 * Import Information
 *
 */
export function importInformationChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-Information' */ '../Information/Information'
  ).then(({ default: Information }) => {
    new Information();
  });
}

/**
 * Import Scroll To Top
 *
 */
export function importScrollToTopChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ScrollToTop' */ '../../ScrollToTop/ScrollToTop'
  ).then(({ default: ScrollToTop }) => {
    new ScrollToTop();
  });
}

/**
 * Import CTA Sticky
 *
 */
export function importCtaStickyChunks() {
  import(
    /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-CtaSticky' */ '../CtaSticky/CtaSticky'
  ).then(({ default: CtaSticky }) => {
    const ctaSticky = new CtaSticky();
    ctaSticky.execute();
  });
}
